import { DELETE_FEED_API, DELETE_VIDEO_API } from 'Constants/community-api'
import getUrl from './url'
import { stringify } from 'querystring'
import fetch from 'lib/decorated-fetch'
interface IProps {
  group_id: string
  video_id?: string
}
const confirmDelete = async ({ group_id, video_id }: IProps) => {
  let url = ''
  const params = {
    item_id: group_id,
    thread_id: group_id,
  }
  if (!video_id) {
    url = `${DELETE_FEED_API}?`
  } else {
    url = `${DELETE_VIDEO_API}?`
  }
  try {
    const json = await fetch(getUrl(url), {
      method: 'POST',
      body: stringify(params),
    })
    if (json.status === 'success' || json.message === 'success') {
      return Promise.resolve('success')
    } else {
      console.error('删除失败', json)
      return Promise.reject('fail')
    }
  } catch (error) {
    console.error(error)
    return Promise.reject('fail')
  }
}

export default confirmDelete
